(function () {
  const SUCCESS_QUERY_PARAM = 'missing_stones_submitted';

  function buildSummary(root) {
    const orderName = root.querySelector('[data-owa-contact-order-name]')?.value || '';
    const colors = root.querySelector('[data-owa-colors]')?.value || '';
    const shape = root.querySelector('[data-owa-shape]:checked')?.value || '';
    const address1 = root.querySelector('[data-owa-address1]')?.value || '';
    const address2 = root.querySelector('[data-owa-address2]')?.value || '';
    const zip = root.querySelector('[data-owa-address-zip]')?.value || '';
    const city = root.querySelector('[data-owa-city]')?.value || '';
    const country = root.querySelector('[data-owa-country]')?.value || '';
    const note = root.querySelector('[data-owa-note]')?.value || '';
    const photoConfirmed = root.querySelector('[data-owa-photo-confirm]')?.checked ? 'Ja' : 'Nee';

    const lines = [
      'Aanvraag ontbrekende steentjes',
      '',
      `Verifieerde bestelling: ${orderName}`,
      `Type steentjes: ${shape}`,
      `Foto wordt apart gemaild: ${photoConfirmed}`,
      '',
      'Ontbrekende kleurcodes en aantallen:',
      colors,
      '',
      'Verzendadres:',
      address1,
      address2,
      `${zip} ${city}`.trim(),
      country,
    ];

    if (note.trim()) {
      lines.push('', 'Extra toelichting:', note);
    }

    return lines.filter((line, index, arr) => !(line === '' && arr[index - 1] === '')).join('\n');
  }

  function setFeedback(node, message, state) {
    if (!node) return;
    node.hidden = !message;
    node.textContent = message || '';
    node.classList.remove('is-error', 'is-success');
    if (message && state) {
      node.classList.add(state === 'error' ? 'is-error' : 'is-success');
    }
  }

  function configureReturnTo(root) {
    const returnToField = root.querySelector('[data-owa-return-to]');
    if (!returnToField) return;

    const url = new URL(window.location.href);
    url.searchParams.set(SUCCESS_QUERY_PARAM, '1');
    url.hash = root.id || '';
    returnToField.value = `${url.pathname}${url.search}${url.hash}`;
  }

  function revealSuccessMessage(root) {
    const successMessage = root.querySelector('[data-owa-submit-success]');
    if (!successMessage) return;

    const url = new URL(window.location.href);
    if (url.searchParams.get(SUCCESS_QUERY_PARAM) !== '1') return;

    successMessage.hidden = false;
    url.searchParams.delete(SUCCESS_QUERY_PARAM);
    history.replaceState({}, document.title, `${url.pathname}${url.search}${url.hash}`);
  }

  function setRequestStepEnabled(root, enabled) {
    const requestStep = root.querySelector('[data-owa-request-step]');
    if (!requestStep) return;

    requestStep.hidden = !enabled;
    requestStep.disabled = !enabled;
  }

  function resetVerifiedOrder(root) {
    [
      '[data-owa-contact-order-number]',
      '[data-owa-contact-postcode]',
      '[data-owa-contact-house-number]',
      '[data-owa-contact-order-id]',
      '[data-owa-contact-order-name]',
      '[data-owa-contact-shipping-summary]',
      '[data-owa-contact-body]',
    ].forEach((selector) => {
      const field = root.querySelector(selector);
      if (field) {
        field.value = '';
      }
    });

    const verifiedSummary = root.querySelector('[data-owa-verified-order-summary]');
    if (verifiedSummary) {
      verifiedSummary.textContent = '';
    }
  }

  async function handleLookup(root) {
    const endpoint = root.dataset.owaLookupEndpoint || '';
    const orderNumberInput = root.querySelector('[data-owa-order-number]');
    const postcodeInput = root.querySelector('[data-owa-postcode]');
    const houseNumberInput = root.querySelector('[data-owa-house-number]');
    const submitButton = root.querySelector('[data-owa-lookup-submit]');
    const feedback = root.querySelector('[data-owa-lookup-feedback]');
    const verifiedSummary = root.querySelector('[data-owa-verified-order-summary]');

    if (!endpoint) {
      setFeedback(feedback, 'De lookup-service is nog niet gekoppeld aan deze section.', 'error');
      return;
    }

    const payload = {
      orderNumber: orderNumberInput?.value || '',
      postcode: postcodeInput?.value || '',
      houseNumber: houseNumberInput?.value || '',
    };

    if (!payload.orderNumber || !payload.postcode || !payload.houseNumber) {
      setFeedback(feedback, 'Vul eerst je bestelnummer, postcode en huisnummer in.', 'error');
      return;
    }

    submitButton.disabled = true;
    setFeedback(feedback, 'We controleren je bestelling...', null);

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (!response.ok || !data.ok) {
        throw new Error(data.message || 'We konden deze bestelling niet valideren.');
      }

      const order = data.order || {};
      const shipping = order.shippingAddress || {};
      const addressSummary = [shipping.address1, shipping.address2, `${shipping.zip || ''} ${shipping.city || ''}`.trim(), shipping.country]
        .filter(Boolean)
        .join(', ');

      root.querySelector('[data-owa-contact-order-number]').value = order.name || payload.orderNumber;
      root.querySelector('[data-owa-contact-postcode]').value = payload.postcode;
      root.querySelector('[data-owa-contact-house-number]').value = payload.houseNumber;
      root.querySelector('[data-owa-contact-order-id]').value = order.id || '';
      root.querySelector('[data-owa-contact-order-name]').value = order.name || '';
      root.querySelector('[data-owa-contact-shipping-summary]').value = addressSummary;

      const nameField = root.querySelector('[data-owa-name]');
      const address1Field = root.querySelector('[data-owa-address1]');
      const address2Field = root.querySelector('[data-owa-address2]');
      const zipField = root.querySelector('[data-owa-address-zip]');
      const cityField = root.querySelector('[data-owa-city]');
      const countryField = root.querySelector('[data-owa-country]');

      if (nameField) nameField.value = shipping.name || '';
      if (address1Field) address1Field.value = shipping.address1 || '';
      if (address2Field) address2Field.value = shipping.address2 || '';
      if (zipField) zipField.value = shipping.zip || '';
      if (cityField) cityField.value = shipping.city || '';
      if (countryField) countryField.value = shipping.country || '';

      verifiedSummary.textContent = `Bestelling ${order.name} gecontroleerd. We hebben het verzendadres alvast voor je ingevuld.`;
      setRequestStepEnabled(root, true);
      setFeedback(feedback, 'Bestelling gecontroleerd. Vul hieronder de ontbrekende steentjes in.', 'success');

      const bodyField = root.querySelector('[data-owa-contact-body]');
      if (bodyField) {
        bodyField.value = buildSummary(root);
      }
    } catch (error) {
      resetVerifiedOrder(root);
      setRequestStepEnabled(root, false);
      setFeedback(
        feedback,
        error instanceof Error ? error.message : 'Er ging iets mis bij het controleren van je bestelling.',
        'error'
      );
    } finally {
      submitButton.disabled = false;
    }
  }

  function bindSummary(root) {
    const watchedFields = root.querySelectorAll(
      '[data-owa-name],[data-owa-email],[data-owa-address1],[data-owa-address2],[data-owa-address-zip],[data-owa-city],[data-owa-country],[data-owa-colors],[data-owa-shape],[data-owa-note],[data-owa-photo-confirm]'
    );
    const bodyField = root.querySelector('[data-owa-contact-body]');
    if (!bodyField) return;

    const sync = () => {
      bodyField.value = buildSummary(root);
    };

    watchedFields.forEach((field) => {
      field.addEventListener('input', sync);
      field.addEventListener('change', sync);
    });
  }

  function initSection(root) {
    if (!root || root.dataset.owaMissingStonesReady === 'true') return;
    root.dataset.owaMissingStonesReady = 'true';

    const requestStep = root.querySelector('[data-owa-request-step]');
    setRequestStepEnabled(root, requestStep ? !requestStep.hidden : false);

    const sourceUrlField = root.querySelector('[data-owa-source-url]');
    if (sourceUrlField && !sourceUrlField.value) {
      sourceUrlField.value = window.location.href;
    }

    configureReturnTo(root);
    revealSuccessMessage(root);

    const lookupButton = root.querySelector('[data-owa-lookup-submit]');
    if (lookupButton) {
      lookupButton.addEventListener('click', () => handleLookup(root));
    }

    bindSummary(root);
  }

  function initAll() {
    document.querySelectorAll('[data-owa-missing-stones-root]').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
